// UltraMed theme JS — hero slider, product thumbnails, toast
(function () {
  // Hero slider
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero-slide');
    var dotsWrap = hero.querySelector('[data-hero-dots]');
    if (slides.length < 2) return;
    var dots = dotsWrap ? dotsWrap.querySelectorAll('button') : [];
    var current = 0;
    var timer = null;
    var autoplay = parseInt(hero.dataset.autoplay || '0', 10);

    function show(i) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (i + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }
    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { show(current + 1); }, autoplay * 1000);
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); restart(); });
    });
    restart();
  });

  // Product page: thumbnail click swaps main image.
  // The main image carries srcset/sizes (F5, 2 Sep 2026). A browser resolves the
  // displayed source from srcset and ignores src, so the swap has to rewrite
  // srcset too — setting src alone changes nothing visible. The srcset is rebuilt
  // from the thumbnail's full-size URL at the same widths the Liquid emits, so the
  // swapped-in image stays responsive; sizes is unchanged (same layout slot).
  var THUMB_WIDTHS = [400, 600, 750, 900, 1200];
  document.querySelectorAll('[data-thumb-for]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.getElementById(thumb.dataset.thumbFor);
      if (!main) return;
      var full = thumb.dataset.full;
      if (/[?&]width=\d+/.test(full)) {
        main.srcset = THUMB_WIDTHS.map(function (w) {
          return full.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w';
        }).join(', ');
      } else {
        main.removeAttribute('srcset');
      }
      main.src = full;
      if (thumb.alt) main.alt = thumb.alt;
    });
  });

  // Purchase confirmation checkboxes: block Add to Cart until all are ticked
  var confirmWrap = document.querySelector('[data-purchase-confirmations]');
  if (confirmWrap) {
    var form = confirmWrap.closest('form');
    var submit = form ? form.querySelector('.btn-add') : null;
    var checks = confirmWrap.querySelectorAll('.confirm-check');
    var update = function () {
      var allTicked = Array.prototype.every.call(checks, function (c) { return c.checked; });
      if (submit && !submit.hasAttribute('data-soldout')) {
        submit.disabled = !allTicked;
        submit.classList.toggle('needs-confirm', !allTicked);
        submit.textContent = allTicked ? 'Add to Cart' : 'Tick the confirmation to continue';
      }
    };
    if (submit && submit.disabled) submit.setAttribute('data-soldout', '');
    checks.forEach(function (c) { c.addEventListener('change', update); });
    update();
  }

  // VAT relief panel: reveal fields when claiming; require them before Add to Cart
  var vatWrap = document.querySelector('[data-vat-relief]');
  if (vatWrap) {
    var vatForm = vatWrap.closest('form');
    var vatSubmit = vatForm ? vatForm.querySelector('.btn-add') : null;
    var vatToggle = vatWrap.querySelector('[data-vat-toggle]');
    var vatFields = vatWrap.querySelector('[data-vat-fields]');
    var vatInputs = vatWrap.querySelectorAll('[data-vat-field]');
    var vatUpdate = function () {
      var claiming = vatToggle.checked;
      vatFields.hidden = !claiming;
      vatInputs.forEach(function (el) {
        // Only submit the declaration properties when the customer is claiming relief
        el.disabled = !claiming;
      });
      if (vatSubmit && !vatSubmit.hasAttribute('data-soldout')) {
        var complete = !claiming || Array.prototype.every.call(vatInputs, function (el) {
          return el.type === 'checkbox' ? el.checked : el.value.trim().length > 1;
        });
        vatSubmit.disabled = !complete;
        vatSubmit.classList.toggle('needs-confirm', !complete);
        vatSubmit.textContent = complete ? 'Add to Cart' : 'Complete the VAT relief declaration to continue';
      }
    };
    if (vatSubmit && vatSubmit.disabled) vatSubmit.setAttribute('data-soldout', '');
    vatToggle.addEventListener('change', vatUpdate);
    vatInputs.forEach(function (el) {
      el.addEventListener('input', vatUpdate);
      el.addEventListener('change', vatUpdate);
    });
    vatUpdate();
  }

  // Toast helper
  window.toast = function (msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('show'); }, 2600);
  };
})();
